import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';

@Injectable({
  providedIn: 'root'
})
export class ReservationPluginService {

  //TODO: make these fields it private
  appBase: string;
  locationId: number;
  systemId: number;
  categoryId: number;
  selectedLocation: string;
  private isOperator: boolean;
  reservationInfo: ReservationPluginInfo;
  private recaptchaSiteKeyV3: string;

  setAppBase(appConfig: any) {
    this.appBase = appConfig.appBase;
    this.locationId = appConfig.locationId;
    this.systemId = appConfig.systemId;
    this.categoryId = appConfig.categoryId;
    this.isOperator = appConfig.isOperator;
    this.selectedLocation = appConfig.selectedLocation;
  }

  constructor(private http: HttpClient) { }

  getReservationData(): Observable<ReservationPluginInfo> {
    return this.http.get<ReservationPluginInfo>(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin/all`);
  }

  createReservation(reservation: TicketReservationPlugin): Observable<string> {
    reservation.categoryId = this.categoryId;

    return this.http.post<string>(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin`, reservation);
  }

  getCategoryId(): number {
    return this.categoryId;
  }

  getSelectedLocation(): string {
    return this.selectedLocation;
  }

  getIsOperator(): boolean {
    return this.isOperator;
  }

  setRecaptchaKey(recaptchaKey: string) {
    this.recaptchaSiteKeyV3 = recaptchaKey;
  }

  getRecaptchaKey() {
    return this.recaptchaSiteKeyV3;
  }
}
